import xhrService from "./common/xhrService";
import formValidation from "./formValidation";
import handleRequestFail from "./handleRequestFail";
import handleRequestSuccess from "./handleRequestSuccess";
const extractDataFromForm = (reservationForm) => ({
    classId: reservationForm.querySelector("[name='lesson']:checked").dataset.class_id,
    lessonId: reservationForm.querySelector("[name='lesson']:checked").value,
    name: reservationForm.querySelector("[name='name']").value,
    tel: reservationForm.querySelector("[name='tel']").value,
    email: reservationForm.querySelector("[name='email']").value,
});
const handleSubmit = (e, reservationForm) => {
    var _a, _b;
    e.preventDefault();
    (_a = reservationForm.querySelector("input[type='submit']")) === null || _a === void 0 ? void 0 : _a.setAttribute("disabled", "disabled");
    formValidation.removeErrorMessage();
    const isFormValid = formValidation.isFormValid(reservationForm);
    if (isFormValid) {
        const data = extractDataFromForm(reservationForm);
        (_b = reservationForm.querySelector("input[type='submit']")) === null || _b === void 0 ? void 0 : _b.classList.add("loading");
        xhrService(new XMLHttpRequest(), handleRequestSuccess(reservationForm), handleRequestFail(reservationForm), "POST", "https://r2imrlb870.execute-api.ap-northeast-1.amazonaws.com/Prod/", [{ key: "Content-Type", value: "application/json" }], data);
    }
    else {
        formValidation.showErrorMessage();
    }
};
export default handleSubmit;
